export class DataSourceResponse<T> {
  data: T[];
  total: number;

  public static default() {
    return { data: [], total: 0 };
  }
}
